export default __webpack_public_path__ + "static/media/ceo.d1ff15b2.png";